export default __webpack_public_path__ + "static/media/edit-time.f7ebc6cb.svg";